module.exports = "/_next/static/images/b93c5d255d49f23d7f07f583b9f7125e-phone-and-card@2x.png";